import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Features', href: '#features' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '/contact', isRoute: true },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'py-3' : 'py-4 md:py-6'
      }`}
      style={{ background: isScrolled ? 'rgba(10, 10, 15, 0.95)' : 'transparent' }}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="nav-wrapper flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#FF6B35] to-[#FF8555] flex items-center justify-center">
              <span className="text-black font-bold text-sm">DP</span>
            </div>
            <span className="text-white font-semibold text-lg hidden sm:block">DP Studios</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.label}
                  to={link.href}
                  className="text-[#B8B8C0] hover:text-white text-sm font-medium transition-colors"
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-[#B8B8C0] hover:text-white text-sm font-medium transition-colors"
                >
                  {link.label}
                </a>
              )
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link 
              to="/contact"
              className="btn-primary text-sm px-5 py-2"
            >
              Build My Site
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 bg-[#12121A] rounded-xl p-4 border border-[#2A2A35] animate-fade-in-up">
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                link.isRoute ? (
                  <Link
                    key={link.label}
                    to={link.href}
                    className="text-[#B8B8C0] hover:text-white font-medium py-2 px-3 rounded-lg hover:bg-[#1A1A24] transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.label}
                    href={link.href}
                    className="text-[#B8B8C0] hover:text-white font-medium py-2 px-3 rounded-lg hover:bg-[#1A1A24] transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {link.label}
                  </a>
                )
              ))}
              <Link 
                to="/contact"
                className="btn-primary w-full mt-2 text-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Build My Site
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
